<template>
  <quizset-form>
    <ButtonUpdate class="mt_m"/>
  </quizset-form>
</template>

<script>
import QuizsetForm from '@/components/EventQuizset/Form'
import ButtonUpdate from '@/components/EventQuizset/ButtonUpdate'

export default {
  components: {
    QuizsetForm,
    ButtonUpdate
  },

  created: async function () {
    this.$store.commit('eventQuizset/setEventId', this.$route.params.id)
    await this.$store.dispatch('eventQuizset/get')
    this.$store.dispatch('eventQuizset/initForm')
  }
}
</script>

